// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"695":"69966720b12dac18","888":"376b3f4bb6cefbe9"}[chunkId] + ".css";
};